export default "__VITE_ASSET__ae867faa__"